import React from "react";
import { FontIcon } from "@fluentui/react";
import { mergeStyles } from "@fluentui/merge-styles";
import { Button, Label } from "@fluentui/react-components";

const wrapperClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

type Props = {
  data: string;
};

export const OpenComparisonDocument: React.FC<Props> = ({ data }) => {
  return (
    <div className={wrapperClass}>
      <Label>Open comparison document</Label>
      <Button
        appearance="primary"
        icon={<FontIcon iconName="WordDocument" />}
        onClick={() => window.open(data)}
      />
    </div>
  );
};
